export default "__VITE_ASSET__CLqBz4s8__"